import { marked } from 'marked';

marked.setOptions({ breaks: true, gfm: true });

const MD_PATTERNS = [
  /^#{1,6}\s+\S/m,       // # 제목
  /^\s*[-*+]\s+\S/m,     // - 목록
  /^\s*\d+\.\s+\S/m,     // 1. 번호목록
  /\*{2}[^*\n]+\*{2}/,   // **볼드**
  /_{2}[^_\n]+_{2}/,     // __볼드__
  /\[.+\]\(.+\)/,        // [링크](url)
  /^```/m,               // 코드블럭
  /^>\s+\S/m,            // > 인용
  /^\|.+\|/m,            // | 테이블 |
];

export function looksLikeMarkdown(text) {
  if (!text || text.length < 8) return false;
  return MD_PATTERNS.some(p => p.test(text));
}

export function markdownToHtml(text) {
  return marked.parse(text);
}
